//@ts-nocheck
import * as actionTypes from './actionTypes';

export const addToBasket = order => ({
  type: actionTypes.ADD_TO_BASKET,
  order,
});

export const deleteItem = id => ({
  type: actionTypes.DELETE_ITEM,
  id,
});

export const changeSetsInBasket = (id, sets) => ({
  type: actionTypes.CHANGE_SETS_IN_BASKET,
  id,
  sets,
});

export const resetPromoCode = () => ({
  type: actionTypes.RESET_PROMOCODE,
});

export const editItemInBasket = (id, step) => ({
  type: actionTypes.EDIT_ITEM_IN_BASKET,
  id,
  step,
});

export const resetEdition = () => ({
  type: actionTypes.RESET_EDITION,
});

export const updateItem = (id, order) => ({
  type: actionTypes.UPDATE_ITEM,
  id,
  order,
});

export const storePromoCode = promoCode => ({
  type: actionTypes.STORE_PROMO_CODE,
  promoCode,
});

export const promoCodeFetchingError = error => ({
  type: actionTypes.PROMO_CODE_ERROR_FETCHING,
  error,
});

export const promoCodeResetError = () => ({
  type: actionTypes.PROMO_CODE_ERROR_RESET,
});

export const resetBasket = () => ({
  type: actionTypes.RESET_BASKET,
});

export const setUsedLoyaltyPoints = points => ({
  points,
  type: actionTypes.SET_USED_LOYALTY_POINTS,
});

export const cancelLoyaltyPoints = points => ({
  points,
  type: actionTypes.CANCEL_LOYALTY_POINTS,
});

export const changeHasPdfFile = boolean => ({
  boolean,
  type: actionTypes.CHANGE_HAS_PDF_FILE,
});

export const changePdfFile = file => ({
  file,
  type: actionTypes.CHANGE_PDF_FILE,
});

export const resetPdfFile = () => ({
  type: actionTypes.RESET_PDF_FILE,
});

export const storeBasket = basket => ({
  type: actionTypes.STORE_BASKET,
  basket,
});

export const addAdditionalFee = product => ({
  type: actionTypes.ADD_ADDITIONAL_FEE,
  product,
});

export const removeAdditionalFee = product => ({
  type: actionTypes.REMOVE_ADDITIONAL_FEE,
  product,
});

export const updateAdditionalFeeList = (value, list) => ({
  type: actionTypes.UPDATE_ADDITIONAL_FEE_LIST,
  list,
  value,
});

export const changeAdditionalFeeAmount = (id, value) => ({
  type: actionTypes.CHANGE_ADDITIONAL_FEE_AMOUNT,
  id,
  value,
});

export const resetAdditionalFeeList = () => ({
  type: actionTypes.RESET_SELECTED_ADDITIONAL_FEE_LIST,
});
